export default __webpack_public_path__ + "static/3-faaecabefd96a70824060545c8a55ada.jpeg";